import React from "react";

/**
 * Renders an SVG icon with specified width, height, and view box, filled with the specified color.
 *
 * @return {JSX.Element} The SVG icon component
 */
export const AppliedIcon = ({ cls }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M25.3333 2.66667H24V1.33333C24 0.597333 23.404 0 22.6667 0C21.9293 0 21.3333 0.597333 21.3333 1.33333V2.66667H10.6667V1.33333C10.6667 0.597333 10.0707 0 9.33333 0C8.596 0 8 0.597333 8 1.33333V2.66667H6.66667C2.99067 2.66667 0 5.65733 0 9.33333V25.3333C0 29.0093 2.99067 32 6.66667 32H25.3333C29.0093 32 32 29.0093 32 25.3333V9.33333C32 5.65733 29.0093 2.66667 25.3333 2.66667ZM6.66667 5.33333H25.3333C27.5387 5.33333 29.3333 7.128 29.3333 9.33333V10.6667H2.66667V9.33333C2.66667 7.128 4.46133 5.33333 6.66667 5.33333ZM25.3333 29.3333H6.66667C4.46133 29.3333 2.66667 27.5387 2.66667 25.3333V13.3333H29.3333V25.3333C29.3333 27.5387 27.5387 29.3333 25.3333 29.3333ZM20.9427 19.3067C21.464 19.828 21.464 20.6707 20.9427 21.192C20.6827 21.452 20.3413 21.5827 20 21.5827C19.6587 21.5827 19.3173 21.452 19.0573 21.192L17.3333 19.468V25.332C17.3333 26.0693 16.7373 26.6653 16 26.6653C15.2627 26.6653 14.6667 26.0693 14.6667 25.332V19.468L12.9427 21.192C12.4213 21.7133 11.5787 21.7133 11.0573 21.192C10.536 20.6707 10.536 19.828 11.0573 19.3067L13.208 17.156C14.7467 15.6173 17.252 15.6173 18.792 17.156L20.9427 19.3067Z"
        fill="currentColor"
      />
    </svg>
  );
};
